module.exports = __webpack_public_path__ + "static/media/login_al_6.3f19cd02.png";